import React from 'react';
import {Provider} from "react-redux";
import configure from "../../../store/configure";
import Layout from "../../../component/layout/Layout";
import InquiryContainer from "../container/InquiryListContainer"

const InquiryListPage = () => {

    return (
        <Provider store={configure}>
            <Layout>
                <InquiryContainer />
            </Layout>
        </Provider>
    );
};

export default InquiryListPage;
